import { ref, set, get, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetUserDataFirebase from "./GetUserDataFirebase";
import SyncReferralMapping from "./SyncReferralMapping";

const EditUserDataInFirebase = async (state, dispatch, userId, userData) => {
    if ((!state?.USERID || state?.USERID == null) && !userId) return null;

    const USERID = state?.USERID || userId;

    try {
        // Reference to the user's profile node
        const userRef = ref(database, `invoiceGenerator/users/${USERID}/user`);
        const snapshot = await get(userRef);
        const userDatas = snapshot.val();

        // 🔹 Sync Referral Mapping (Ensure code exists and is mapped globally)
        const finalReferralCode = await SyncReferralMapping(USERID, userData || userDatas || state?.SET_USER, dispatch);

        // User profile data to store
        const userProfile = {
            social_id: userData?.social_id || state?.SET_USER?.social_id || state?.SET_USER?.user_uid,
            name: userData?.name || userDatas?.name || '',
            email: userData?.email || userDatas?.email || '',
            contact: userData?.contact || userDatas?.contact || '',
            currency: userData?.currency || userDatas?.currency || 'IND',
            user_uid: userData?.user_uid || userDatas?.user_uid || '',
            platform: "website",
            razorpayId: "",
            referral_code: finalReferralCode || userData?.referral_code || userDatas?.referral_code || state?.SET_USER?.referral_code || "",
            referredBy: userData?.referredBy || userDatas?.referredBy || state?.SET_USER?.referredBy || "",
        };

        // Save or overwrite the user data
        await update(userRef, userProfile);
        
        await GetUserDataFirebase(USERID);

        return { success: true, message: "User profile saved successfully!" };
    } catch (error) {
        console.error("Firebase Error:", error);
        return { success: false, message: error.message || "Failed to save user data" };
    }
};

export default EditUserDataInFirebase;
